import failureDialog from '../UI/failureDialog';
import { CLOSE } from './resultTypes';
import { RULESET_RESULT_CLOSE, RULESET_RESULT_NORMAL } from './ruleSetResults';

// BUGBUG - This function should not have SharePoint-specific handling. 
// We should probably have some shared function for extracting the "user friendly" error from an error, 
// or some other approach (e.g.make sure shpErrors are unwrapped before they leave the SharePoint handling modules)
// Error -> String
function getErrorDetails(error) {
    if (error) {
        if (error.shpError && error.shpError.get_message) {
            return error.shpError.get_message();
        }

        if (error.message) {
            return error.message;
        }
    }

    return '(error unspecified)';
}

export default function ruleSetExecutor(ruleExecutor, logging) {
    // (String, Error) -> Promise
    function handleRuleError(ruleName, error) {
        const errMsg = `The '${ruleName}' rule was not applied.`;
        const errDetails = getErrorDetails(error);

        logging.logError(`Rule execute error. ${errMsg}, ${errDetails}`, error);

        const fd = failureDialog('Rule Error', errMsg, errDetails);

        return fd.showAsync();
    }


    // ([Rule], DataSourceNode) -> Promise[RuleResult]
    // runs the specified rules until a rule result indicates a stop event
    // or all are complete, and returns the last result or the stop event if there
    // was one
    async function runRulesAsync(rules, context) {
        for (const rule of rules) {
            try {
                const result = await ruleExecutor.runRuleAsync(rule, context);

                if (result.shouldStop) {
                    // Pass up the close result if a rule returned one
                    return result.status === CLOSE
                        ? RULESET_RESULT_CLOSE
                        : RULESET_RESULT_NORMAL;
                }
            } catch (error) {
                console.error("RuleSet failed", error);

                await handleRuleError(rule.caption, error);

                return RULESET_RESULT_NORMAL;
            }
        }

        return RULESET_RESULT_NORMAL;
    }

    return {
        // (RuleSet, DataSourceNode) -> Promise[RuleSetResult]
        // runs the rules in the ruleSet and returns the outcome
        runRuleSetAsync: (ruleSet, context) =>
            runRulesAsync(ruleSet.rules, context),
    };
}